import React, { useState } from 'react';
import { Wallet } from "../../modules/DetailsCart";
import Delivery  from "../../modules/DetailsCart/components/Delivery/Delivery";
import PaymentInfo from "../../modules/DetailsCart/components/PaymentInfo/PaymentInfo";

export default function Cart() {
  const [showPaymentInfo, setShowPaymentInfo] = useState(false);

  const handleButtonClick = () => {
    setShowPaymentInfo(!showPaymentInfo);
  };

  return (
    <>
      {!showPaymentInfo && <Delivery/>}
      
      {showPaymentInfo && <PaymentInfo />}
      <Wallet />
      <button onClick={handleButtonClick}>
        {showPaymentInfo ? 'Proceed to Payment' : 'Confirm Shipping Address'}
      </button>
    </>
  );
}
